import closest from '@mailobj-browser/front/js/selectors/closest.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'

const controls = new WeakMap()
const counters = new WeakMap()
let counter = 0

export const selector = '[data-contract~="field.main"]'

const getMain = element => {
  const main = closest('[data-contract~="field.main"]', element)
  
  if (!counters.has(main)) {
    counters.set(main, counter)
    controls.set(main, new Set())
    counter += 1
  }
  
  return main
}

export const control = element => {
  const main = getMain(element)
  
  controls.get(main).add(element)
}

export const handle = (element, aria) => {
  const main = getMain(element)
  const counter = counters.get(main)
  const id = `ea-${aria}${counter}`
  const fields = controls.get(main)
  
  for (const field of fields) {
    field.setAttribute(`aria-${aria}`, id)
  }
  
  element.id = id
  
  return fields
}

export default main => {
  queueMicrotask(async () => {
    await removed(main)
    controls.delete(main)
    counters.delete(main)
  })
}
